/** @jsxImportSource ../../i18n */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, PiggyBank } from 'lucide-react';
import api from '../../services/api';
import { ceilingUsedPct } from '../../services/pea';
import { formatDate, formatNumber } from '../../theme/format';
import { Badge, Button, Card, CardHeader, Money, Progress, Skeleton } from '../ui';

// Dashboard summary of the PEA counter: deposit ceiling and five-year date.
export const PEASummaryCard = () => {
  const [status, setStatus] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get('/pea/status')
      .then((res) => { if (alive) setStatus(res.data); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, []);

  if (failed) return null;
  const used = ceilingUsedPct(status);
  return (
    <Card data-testid="pea-summary">
      <CardHeader
        icon={PiggyBank}
        title="Votre PEA"
        actions={<Button as={Link} to="/pea" variant="link" trailingIcon={ArrowRight}>Compteur</Button>}
      />
      {!status && <div aria-hidden="true"><Skeleton className="h-3 w-full" /><Skeleton className="mt-4 h-3 w-2/3" /></div>}
      {status?.profile_incomplete && (
        <p className="text-sm leading-relaxed text-fg-muted">
          Renseignez la date d’ouverture et vos versements pour suivre le plafond et la date des 5 ans.{' '}
          <Link to="/pea" className="font-medium text-gold-300 underline-offset-4 hover:underline">Compléter</Link>
        </p>
      )}
      {status && !status.profile_incomplete && (
        <dl className="space-y-5">
          <div>
            <div className="flex items-baseline justify-between gap-3">
              <dt className="eyebrow">Plafond utilisé</dt>
              <dd className="num text-sm text-fg">{formatNumber(used, { decimals: 0 })} %</dd>
            </div>
            <Progress value={used} max={100} className="mt-2" />
            <dd className="mt-2 text-xs text-fg-subtle">Reste <Money value={status.remaining} decimals={0} className="text-fg-body" /> à verser</dd>
          </div>
          <div className="flex items-center justify-between gap-3">
            <dt className="eyebrow">Antériorité</dt>
            <dd>
              {status.matured
                ? <Badge tone="gain" dot>5 ans atteints</Badge>
                : <span className="num text-sm text-fg">{formatNumber(status.days_to_maturity)} j · {formatDate(status.maturity_date)}</span>}
            </dd>
          </div>
        </dl>
      )}
    </Card>
  );
};
